export default "__VITE_ASSET__B8uo4tup__"